export var MOBILE_LINK_CHOICE_KEY = "WALLETCONNECT_DEEPLINK_CHOICE";
export var mobileLinkChoiceKey = MOBILE_LINK_CHOICE_KEY;